var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ranking-entry',{attrs:{"streamer":_vm.result.streamerUser,"currentStatus":_vm.currentStatus,"rank":_vm.result.rank,"score":_vm.result.score}})
}
var staticRenderFns = []

export { render, staticRenderFns }